import { memo } from 'react';

import {
  FormattedMessageTypography,
  type FormattedMessageTypographyProps,
  Typography,
} from '@didaskill/ui/design-system';

export type NotificationListItemFormattedMessageProps = FormattedMessageTypographyProps;

export const NotificationListItemFormattedMessageBase = ({
  typographies = null,
  ...props
}: NotificationListItemFormattedMessageProps) => (
  <FormattedMessageTypography
    {...props}
    typographies={{ b: Typography.VARIANTS.BODY_SMALL_BOLD, ...typographies }}
  />
);

NotificationListItemFormattedMessageBase.displayName = 'NotificationListItemFormattedMessage';

export const NotificationListItemFormattedMessage = memo(NotificationListItemFormattedMessageBase);
